import React, { Component } from 'react'

import { Loader } from 'semantic-ui-react'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser'
import ArticleAudio from './ArticleAudio'
import ArticleImage from './ArticleImage'
import ArticleVideo from './ArticleVideo'
import moment from 'moment'

class GenericContent extends Component {
  render () {
    const { loading, topicle, detail_topicle } = this.props

    return (
      <div className='Article'>
        <Loader active={loading} className='article-loader' />
        {topicle && detail_topicle ? this.renderMainContent() : null}
      </div>
    )
  }
}

class Article extends GenericContent {

  renderHeader () {
    const { detail_topicle } = this.props
    let { needs_header='dont_know' } = this.props

    if (needs_header === 'dont_know') {
      const content = detail_topicle.content || detail_topicle.content_html_body || detail_topicle.article_html
      needs_header = content && content.indexOf('<header') === -1
    }

    if (needs_header) {
      const pubdate = detail_topicle.version_created || detail_topicle.versioncreated || detail_topicle.updated
      return (
        <header>
          { this.renderSlugline() }
          { this.renderRubrics() }
          <time className='publicationDate'>{ pubdate ? moment(pubdate).format('DD.MM.YYYY HH:mm') : '' }</time>
          { detail_topicle.genre_names ? (<p className='genre'>{ detail_topicle.genre_names[0] }</p>) : null }
          <h3>{ detail_topicle.kicker || '' }</h3>
          <h1>{ detail_topicle.title || detail_topicle.headline }</h1>
        </header>
      )
    }

    //    <h2>{ detail_topicle.subhead || '' }</h2>
  }

  renderSlugline () {
    const { detail_topicle } = this.props
    let slugline = []
    slugline = slugline.concat(detail_topicle.dpasubject_names || [])
    slugline = slugline.concat(detail_topicle.geoarea_names || [])
    slugline = slugline.concat(detail_topicle.keyword_names || [])
    return (
      <ul className='slugline'>
        { slugline.map(name => (<li>{ name }</li>)) }
      </ul>
    )
  }

  renderRubrics () {
    const { detail_topicle } = this.props
    let rubrics = detail_topicle.rubric_names || []
    return (
      <ul className='rubrics'>
        { rubrics.map(name => (<li>{ name }</li>)) }
      </ul>
    )
  }

  makeTransformHtml () {
    const { detail_topicle } = this.props
    function addTargetBlank (node) {
      if (node.type === 'tag' && node.name === 'a') {
        // all links must open in a new window
        node.attribs.target = '_blank'
      }
      return node
    }
    const innerHtmlOptions = {transform: function innerTransform (node, index) {
      node = addTargetBlank(node)
      return convertNodeToElement(node, index, innerTransform)
    }}
    function transform (node, index) {
      node = addTargetBlank(node)

      if (node.type === 'tag' && node.name === 'dnl-image') {
        // Handle dnl-image
        const images = detail_topicle.media_groups || detail_topicle.associations
        const img = images.find(a => a.urn === node.attribs.ref)
        const content = img.renditions || img.contents
        node.attribs.src = node.attribs.src ? node.attribs.src : content[0].url
      }
      
      if (node.type === 'tag' && node.name === 'section' && node.attribs.class && (node.attribs.class.indexOf('main') !== -1 || node.attribs.class.indexOf('body') !== -1)) {
        return (
          <article key={index}>
            {this.renderHeader()}
            <div>
              <p className='teaser above-image'>{ detail_topicle.teaser || '' }</p>
              <ArticleImage topicle={detail_topicle} />
              { convertNodeToElement(node, index, transform) }
              { detail_topicle.infobox_html && (<h4 className='infobox'>Infobox</h4>) }
              { detail_topicle.infobox_html && ReactHtmlParser(detail_topicle.infobox_html, innerHtmlOptions) }
              { detail_topicle.linkbox_html && (<h4 className='infobox'>Linkbox</h4>) }
              { detail_topicle.linkbox_html && ReactHtmlParser(detail_topicle.linkbox_html, innerHtmlOptions) }
            </div>
          </article>
        )
      }
    }
    return transform.bind(this)
  }

  getDocType () {
    const { topicle } = this.props
    // try to guess without tags (and without type)
    if (!topicle.tags) {
      if (!topicle.article_html && (topicle.images || topicle.featureimage || topicle.associations || topicle.media_groups)) {
        // TODO more tests
        if ((topicle.associations || []).findIndex(a => a.type === 'graphic') === 0) {
          return 'dnldoctype:graphic'
        } else if ((topicle.associations || []).findIndex(a => a.type === 'video') === 0) {
          return 'dnldoctype:video'
        } else if ((topicle.associations || []).findIndex(a => a.type === 'audio') === 0) {
          return 'dnldoctype:audio'
        }
        return 'dnldoctype:image'
      }
      return 'dnldoctype:topicle'
    }
    // for images we do not use retrieved detail_topicle (may be topicles() gql does not retrieve an image -- but we have all we need in props.topicle)
    if ((topicle.tags || []).indexOf('dnldoctype:image') > -1) {
      return 'dnldoctype:image'
    } else if ((topicle.tags || []).indexOf('dnldoctype:graphic') > -1) {
      return 'dnldoctype:graphic'
    } else if ((topicle.tags || []).indexOf('dnldoctype:video') > -1) {
      return 'dnldoctype:video'
    }  else if ((topicle.tags || []).indexOf('dnldoctype:audio') > -1) {
      return 'dnldoctype:audio'
    } else {
      return 'dnldoctype:topicle'
    }
  }

  renderMainContent () {
    const { topicle, detail_topicle } = this.props
    const dt = this.getDocType()

    if (dt === 'dnldoctype:image') {
      return (
        <div className='dpa-article image-article'>
          <article>
            <ArticleImage
              topicle={topicle}
              with_long_caption={true}
              with_viewport={false}
              with_urn_and_version_info={true} />
          </article>
        </div>
      )
    } else if (dt === 'dnldoctype:graphic') {
      return (
        <div className='dpa-article image-article graphic-article'>
          <article>
            <ArticleImage
              topicle={topicle}
              with_long_caption={true}
              with_viewport={false}
              with_urn_and_version_info={true} />
          </article>
        </div>
      )
    } else if (dt === 'dnldoctype:video') {
      return (
        <div className='dpa-article'>
          <article>
            <ArticleVideo
              topicle={topicle}
              with_long_caption={true}
              with_viewport={false}
              with_urn_and_version_info={true} />
          </article>
        </div>
      )
    } else if (dt === 'dnldoctype:audio') {
      return (
        <div className='dpa-article'>
          <article>
            <ArticleAudio
              topicle={topicle}
              with_long_caption={true}
              with_urn_and_version_info={true} />
          </article>
        </div>
      )
    }
    else {
      const html = detail_topicle && (detail_topicle.content || detail_topicle.article_html || '')
      const htmlOptions = {transform: this.makeTransformHtml()}
      return (
        <div className='dpa-article'>{ReactHtmlParser(html, htmlOptions)}</div>
      )
    }
  }
}

export { Article }



// WEBPACK FOOTER //
// ./src/probish/Article.js